import script from "./CollapsibleSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollapsibleSection.vue?vue&type=script&lang=ts&setup=true"

import "./CollapsibleSection.vue?vue&type=style&index=0&id=9ddcc516&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ddcc516"]])

export default __exports__